const RegexSetting = {
    normalUrl: /(https?:\/\/\S+)/g,
  }

  export  default RegexSetting;